var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenarioErrorBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 411,
    viewBox: "0 0 333 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-181 62.7111C-181 62.7111 4.23999 -27.0589 110.65 8.21114C217.06 43.4811 323.47 340.041 323.47 340.041C323.47 340.041 360.47 435.481 285.03 509.451C253.15 540.691 207.69 560.701 158.32 566.611C71.11 577.041 -129 595.701 -181 554.751V62.7111Z",
    fill: "url(#paint0_linear_1265_152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.729 331.746C138.789 344.84 151.073 353.785 164.167 351.725C177.261 349.665 186.206 337.38 184.146 324.287C182.086 311.193 169.801 302.248 156.708 304.308C143.614 306.368 134.669 318.652 136.729 331.746Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7289 186.746C21.7887 199.84 34.0732 208.785 47.167 206.725C60.2608 204.665 69.2056 192.38 67.1457 179.287C65.0859 166.193 52.8014 157.248 39.7076 159.308C26.6138 161.368 17.669 173.652 19.7289 186.746Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.338 363.488C193.368 370.035 199.51 374.508 206.057 373.478C212.604 372.448 217.076 366.305 216.046 359.759C215.017 353.212 208.874 348.739 202.327 349.769C195.781 350.799 191.308 356.941 192.338 363.488Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.41 312.077C198.869 321.352 207.571 327.688 216.846 326.229C226.121 324.77 232.456 316.068 230.997 306.793C229.538 297.519 220.837 291.183 211.562 292.642C202.287 294.101 195.951 302.802 197.41 312.077Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.397 354.465C231.169 359.375 235.776 362.73 240.686 361.957C245.596 361.185 248.95 356.578 248.178 351.668C247.405 346.758 242.799 343.404 237.889 344.176C232.978 344.948 229.624 349.555 230.397 354.465Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3986 189.688C87.171 194.598 91.7777 197.952 96.6879 197.18C101.598 196.408 104.952 191.801 104.18 186.891C103.407 181.98 98.8008 178.626 93.8906 179.399C88.9804 180.171 85.6261 184.778 86.3986 189.688Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1265_152",
    x1: 75.7713,
    y1: 0,
    x2: 75.7713,
    y2: 580.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F8ECC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972916,
    stopColor: "#2980B9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenarioErrorBottom);
export default __webpack_public_path__ + "static/media/CenarioErrorBottom.7aee6fed81054056b54bf90fd50036e4.svg";
export { ForwardRef as ReactComponent };